import type { MouseEvent, ReactNode } from "react"

function isModifiedEvent(event: MouseEvent<HTMLAnchorElement>) {
  return event.metaKey || event.ctrlKey || event.shiftKey || event.altKey
}

export function navigate(pathname: string) {
  window.history.pushState({}, "", pathname)
  window.dispatchEvent(new PopStateEvent("popstate"))
}

export function Link({
  href,
  className,
  onClick,
  children,
}: {
  href: string
  className?: string
  onClick?: () => void
  children: ReactNode
}) {
  return (
    <a
      href={href}
      className={className}
      onClick={(event) => {
        if (
          event.defaultPrevented ||
          isModifiedEvent(event) ||
          event.button !== 0 ||
          href.startsWith("http")
        ) {
          return
        }

        event.preventDefault()
        navigate(href)
        onClick?.()
      }}
    >
      {children}
    </a>
  )
}
